// removed by extract-text-webpack-plugin
module.exports = {"brand":"src-components-Brand----brand-module---brand---1pB3H","brandInner":"src-components-Brand----brand-module---brandInner---1yPJd","brandOverlay":"src-components-Brand----brand-module---brandOverlay---1DItg","active":"src-components-Brand----brand-module---active---27EeR","brandImage":"src-components-Brand----brand-module---brandImage---2lrHd","logoImage":"src-components-Brand----brand-module---logoImage---2qxid"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Brand/brand.module.scss
// module id = 270
// module chunks = 114276838955818